module.exports = __webpack_public_path__ + "static/media/favicon.4859e39a.ico";